import { isFedRamp } from '@atlaskit/atlassian-context/is-fedramp';
import { ProductEnvironment, ForgeCDNEnvironment } from '@atlassian/forge-ui-types/environments';

export const getCDNEnvironment = (productEnvironment: ProductEnvironment): ForgeCDNEnvironment => {
	if (isFedRamp()) {
		if (productEnvironment === ProductEnvironment.STAGING) {
			return ForgeCDNEnvironment.STAGING;
		} else {
			return ForgeCDNEnvironment.PRODUCTION;
		}
	}

	if (productEnvironment === ProductEnvironment.DEVELOPMENT) {
		return ForgeCDNEnvironment.DEVELOPMENT;
	} else if (productEnvironment === ProductEnvironment.STAGING) {
		return ForgeCDNEnvironment.STAGING;
	} else {
		return ForgeCDNEnvironment.PRODUCTION;
	}
};
